import cityList from '../tools/cityList';

const adcodeCenterMap = {};
cityList.forEach(item => {
  adcodeCenterMap[item.adcode] = item.center;
});

const pngMap = {
  '多云': 'https://lark-assets-prod-aliyun.oss-cn-hangzhou.aliyuncs.com/yuque/0/2020/png/369892/1592894418896-resources/1201348/png/67a822ba-c553-42e7-82f2-1cd35a4265b9.png?OSSAccessKeyId=LTAI4GGhPJmQ4HWCmhDAn4F5&Expires=1592896353&Signature=rzljyKJP4gVKN3HZcbgQeEZH63g%3D',
  '阴': 'https://lark-assets-prod-aliyun.oss-cn-hangzhou.aliyuncs.com/yuque/0/2020/png/369892/1592894419103-resources/1201348/png/1fb9c117-2bd9-4d0e-9323-c4a43704eaaf.png?OSSAccessKeyId=LTAI4GGhPJmQ4HWCmhDAn4F5&Expires=1592896317&Signature=Gm8fJSA%2BV2BjvuczNuFgnC5ugls%3D',
  '雨': 'https://lark-assets-prod-aliyun.oss-cn-hangzhou.aliyuncs.com/yuque/0/2020/png/369892/1592894419447-resources/1201348/png/8c5aeac3-db47-46d3-bb91-f51690b2f3eb.png?OSSAccessKeyId=LTAI4GGhPJmQ4HWCmhDAn4F5&Expires=1592896289&Signature=4Vk6KoA0s%2FcuKgiIuRpzhMzDwXI%3D',
  '晴': 'https://lark-assets-prod-aliyun.oss-cn-hangzhou.aliyuncs.com/yuque/0/2020/png/369892/1592894419927-resources/1201348/png/f744a23d-9fc4-4e68-9a16-e2b45c82c700.png?OSSAccessKeyId=LTAI4GGhPJmQ4HWCmhDAn4F5&Expires=1592896343&Signature=PhjAzGOrigw55A9%2FkORWiyLIzZw%3D',
  '雪': 'snow',
};

export default class MapRender {
  constructor() {
    this.drawer = {
      visible: false,
      data: {}
    };
    this.map = new AMap.Map("container", {
      mapStyle: "amap://styles/darkblue",
      zoom: 4.5,
      resizeEnable: true,
      pitch: 0,
      center: [104.090834, 31.270677],
      features: ["bg", "road"],
      viewMode: "3D"
    });
  }

  /**设置数据 */
  setData(data) {
    const cleanData = data.map(item => {
      if (item) {
        return item
      } else {
        return [];
      }
    });
    this._setLabelLayerData(cleanData);
    this._setLabelLayerEvent();
  }
  /**设置文字层数据 */
  _setLabelLayerData(cleanData) {
    // 1. 如果层存在,清楚layer层
    if (this.layer) {
      this.layer.setMap(null);
    }
    // 2. 新建layer层
    this.layer = new Loca.LabelsLayer({
      fitView: true,
      map: this.map,
      collision: true
    });
    // 3. 设置数据
    this.layer.setData(cleanData, {
      type: 'json',
      lnglat: 'center',
    }).setOptions({
      style: {
        direction: 'center',
        offset: [0, 9],
        text: (data) => {
          const value = data.value;
          return `${value.city}: ${value.weather} ${value.temperature}℃`
        },
        fillColor: (data) => {
          const temperature = data.value.temperature;
          const weather = data.value.weather;
          return this._getColor(temperature, weather);
        },
        fontSize: (data) => {
          return 12;
        },
        strokeWidth: 0
      },
      // selectStyle: {
      //   fillColor: '#FFF684'
      // }
    }).render()

    // 4. 设置层级
    this.layer.setzIndex(100);
  }
  /**设置鼠标选中事件 */
  _setLabelLayerEvent() {
    const _this = this;
    this.layer.on('click', function(ev) {
      const cityData = ev.overlay.properties;
      _this.drawer.visible = true;
      _this.drawer.data = cityData;
    })
  }
  /**添加center坐标 */
  _addCenter(item) {
    const { adcode } = item;
    item.center = adcodeCenterMap[adcode];

    return item;
  }
  /**获取颜色 */
  _getColor(tempature, weather) {
    if (weather === '雨') {
      return '#15A3FA';
    } else if (weather === '晴'){
      return '#fc8d59';
    } else if(weather === '多云' || weather === '阴') {
      return '#EFF0F1';
    } else {
      return '#99d594';
    }
  }
}